// extracted by mini-css-extract-plugin
export var badgeImage = "TrustedByV2-module--badgeImage--DaPyK";
export var limitWidthOnLargeScreens = "TrustedByV2-module--limitWidthOnLargeScreens--vEYyY";
export var line = "TrustedByV2-module--line--ytDQ2";
export var logo = "TrustedByV2-module--logo--vSx28";
export var logoTablet = "TrustedByV2-module--logoTablet--xaypv";
export var logosAndPerformerContainer = "TrustedByV2-module--logosAndPerformerContainer--dRRSi";
export var logosContainer = "TrustedByV2-module--logosContainer--gjCD4";
export var moveCardTablet = "TrustedByV2-module--moveCard-tablet--uLZvp";
export var outerContainer = "TrustedByV2-module--outerContainer--kqpXj";
export var performerBadge = "TrustedByV2-module--performerBadge--O-1q9";
export var performerContainer = "TrustedByV2-module--performerContainer--gyP03";
export var rowContainer = "TrustedByV2-module--rowContainer--wOzZT";
export var score = "TrustedByV2-module--score--3++7Q";
export var scoreText = "TrustedByV2-module--scoreText--iyNAg";
export var stars = "TrustedByV2-module--stars--Sxz+b";
export var title = "TrustedByV2-module--title--19Wkc";
export var trustedByContainer = "TrustedByV2-module--trustedByContainer--YAAkE";